module.exports = __webpack_public_path__ + "81522df433e23f46cf358efda063cc2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_lg.png
// module id = 577
// module chunks = 0